module.exports = __webpack_public_path__ + "img/a.b.7ddf7f8b.svg";